'use strict';

import template from './multiselect.html';

const saMultiselect = [
  'languages',

  function () {
    return {
      template: template,
      replace: true,
      transclude: true,
      require: 'ngModel',
      scope: {
        data: '='
      },
      link: function ($scope, $element, $attr, ngModel) {
        function updateViewValue() {
          var newValue = $scope.selectedItems.map(function (item) {
            return item.value;
          });

          ngModel.$setViewValue(newValue);
        }

        function sortSelectedItems() {
          $scope.selectedItems.sort(function (a, b) {
            return (a.value > b.value) ? 1 : (a.value < b.value) ? -1 : 0;
          });
        }

        function addItem(item) {
          $scope.selectedItems.push(item);
        }

        $scope.removeItem = function (index) {
          $scope.selectedItems.splice(index, 1);
          updateViewValue();
        };

        ngModel.$render = function () {
          var selectedItems = (ngModel.$modelValue || []).map(function (item) {
            return $scope.data.all[item];
          });

          $scope.selectedItems = selectedItems;
        };

        $scope.$watch('data', function () {
          $scope.options = $scope.data.options;
        });

        $scope.$watch('selectedItem', function (newValue) {
          if (newValue) {
            addItem($scope.data.all[newValue]);
            sortSelectedItems();
            updateViewValue();
            delete $scope.selectedItem;
          }
        });
      }
    };
  }
];

export default saMultiselect;



// WEBPACK FOOTER //
// ./app/src/directives/multiselect.js